/**
 *
 * @param {string} street - A complete street
 * @returns {{street: string, number?: string, letter?: string}} a object contains the splitting value
 */
export const splitStreetToParts = text => {
	let backwards = /^(\d+(?:[-./]\d+)?)(.*?)\s(.*?)$/
	let forwards = /^(.*?)\s+(\d+(?:[-./]\d+)?)(?:\s*(\S.*))?$/
	if (!text) {
		return {
			street: "",
			number: "",
			letter: "",
		}
	}
	try {
		const [_, number, letter, street] = text.match(backwards)
		return {
			street,
			number,
			letter,
		}
	} catch {
		const [_, street, number, letter] = text.match(forwards)
		return {
			street,
			number,
			letter,
		}
	}
}
